import { useMemo } from "react";
import PromoteSurfaceView from "@/react/features/promoteSurface/components/PromoteSurfaceView";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";

export const PromoteSurfacePage = () => {
  const { project, user } = useSwivuBryntumContext();

  const boardUserAvailable = useMemo(() => {
    if (!user?.id || !project?.boardUsersStore) return false;
    return Boolean(
      project.boardUsersStore.find((boardUser) => (boardUser as { userId?: number }).userId === user.id)
    );
  }, [project, user]);

  return (
    <div
      className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0"
      id="promote-surface-page"
    >
      <div className="flex-1 min-h-0">
        <PromoteSurfaceView boardUserAvailable={boardUserAvailable} />
      </div>
    </div>
  );
};

export default PromoteSurfacePage;
